module.exports = __webpack_public_path__ + "img/test.ca1e605f.svg";